/**
 * An order is "amended" when it carries poaChildOrderId — the linkage to the order it
 * replaced. The API returns '' (not null/absent) for unset, so a truthiness check is
 * required rather than a presence check.
 */
export const isAmendedOrder = (row) => Boolean(row?.poaChildOrderId)

export default isAmendedOrder
